import { Wrapper, IconSelect, Select } from './SelectPagination.style'

interface SelectPaginationProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /** Total de páginas que serão adicionadas ao seletor */
  totalPages?: number

  /** Estilo do do seletor para contraste com fundo escuro  */
  isLight?: boolean
}

const normalizePage = (page: number) => page + 1

export const SelectPagination = ({ totalPages, isLight, ...props }: SelectPaginationProps) => (
  <Wrapper>
    <IconSelect
      size={18}
      color={isLight ? '$nonInteractiveAltPredominant' : '$backgroundAltPrimary'}
    />
    <Select
      isLight={isLight}
      {...props}
      aria-label="Selecionar número de página"
    >
      {[...Array(totalPages)].map((_, index) => (
        <option
          key={`pagination-${index}`}
          value={index}
        >
          {normalizePage(index)} de {totalPages}
        </option>
      ))}
    </Select>
  </Wrapper>
)
